module.exports = __webpack_public_path__ + "static/media/tidak-mampu.75c49ddd.png";